"use client";

import { createContext, useContext } from "react";
import type { RelayDepositProps } from "../types";

/**
 * Carries `<RelayDeposit>`'s own configuration (client/recipient/amount/wallet
 * capabilities/callbacks) from the compound root down to
 * `<RelayDeposit.Content>`, which is supplied by the host as a child and so
 * can't receive them as props.
 *
 * Deliberately separate from `RelayShellContext`
 * (`./relay-shell-provider.tsx`): that one is the *shell's* concern (open
 * state, viewport, theme, portal style) and is shared with any future
 * relay compound built on `ResponsiveShell`, while this one is the deposit
 * widget's data. Mirrors how `WalletConnectModal` keeps its wallet registry
 * and its modal state in a single context only because that component has no
 * second compound — the relay shell already has two consumers.
 */
export const RelayDepositContext = createContext<RelayDepositProps | null>(null);

export function useRelayDepositContext(): RelayDepositProps {
  const ctx = useContext(RelayDepositContext);
  if (!ctx) {
    throw new Error(
      "RelayDeposit compound components must be used within <RelayDeposit>",
    );
  }
  return ctx;
}
